import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useUser } from '../../../../../Context/UserContext';

export default function VtsBasketConfirmed() {
  const { user } = useUser();
  if (user?.is_exhibitor) {
    return null;
  }
  return (
    <Container>
      <Row>
        <Col>
          Thanks for your confirmation. You can now release your order in the <a href="https://naskorsports.com/vts-order">Service Center</a>. Several partial releases are possible and will be invoiced accordingly.<br/>
          Final order release is 30th of June 2026.<br/>
          In regards to product availability, we advise you to be fast: FIRST COME FIRST SERVE
        </Col>
      </Row>
    </Container>
  );
}
